"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Help["default"];
  }
});
var _Help = _interopRequireDefault(require("./Help"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }